const NavMobile = (function () {
    'use strict'

    let nav;
    let listitems;
    let backbutton;
    let currentLevel;

    /*
     * mark list elements which are expanded
     * and remove attribute for all other items on the same level
     */

    const markOpen = function (item) {
        $(item).siblings().removeAttr('data-is-open');
        $(item).attr('data-is-open', '');
    }


    /*
     * show backbutton if we can go back a level only
     */

    const setBackbutton = function () {
        if (currentLevel > 1) {
            $(backbutton).show()
        } else {
            $(backbutton).hide();
        }
    }

    /*
     * manipulate variable to reflect current navigation level
     * and perform related tasks
     */

    const setLevel = function () {
        $(nav).attr('data-show-level', currentLevel);
    }


    const nextLevel = function () {
        if (currentLevel < 5) {
            ++currentLevel;
            setLevel();
            setBackbutton();
        }
    }

    const previousLevel = function () {
        if (currentLevel > 1) {
            --currentLevel;
            setLevel();
            setBackbutton();
        }
    }

    /*
     * perform tasks which reset all menu states
     */

    const reset = function () {
        window.setTimeout(function () {
            currentLevel = 1;
            setLevel();
            setBackbutton();
            $(listitems).removeAttr('data-is-open');
        }, 1000);
    }

    const init = function () {
        // cache selectors
        nav = $('[data-hook=nav]');
        listitems = $('[data-hook=nav] li:has(ul)');
        currentLevel = $(nav).attr('data-show-level');
        // dynamically add backbutton
        $(nav).prepend('<button class="nav-backbutton" data-hook="backbutton">zurück</button>');
        backbutton = $('[data-hook=backbutton]');

        // initialize states
        setBackbutton();

        // add behaviors
        $('li[data-has-children] > a').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            markOpen($(this).parent());
            nextLevel();
        });

        // move overview links to childrens' list
        $('li[data-has-children]').each(function () {
            const link = $(this).find('> a');
            const label = $(link).attr('data-label') ? $(link).attr('data-label') : $(link).text();
            const href = $(link).attr('href');
            const sublist = $(this).find('> [data-level]');
            $(link).removeAttr('href');
            $(sublist).prepend('<li><a href="' + href + '">' + label + '</a></li>');
        });

        $(backbutton).on('click', function () {
            previousLevel();
        });
    }

    return {
        init: init,
        reset: reset,
    }

})();
